(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template-mbc-backup"]) return;
  try {
    

function updateOrderNotes(ddlGroups){
	var selectedValue = ddlGroups.value;
	//alert(selectedValue);

	if(selectedValue == "Other"){

	
}else {

	document.getElementsById('CartSpecialInstructions').text = selectedValue;
}

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    

function updateOrderNotes(ddlGroups){
	var selectedValue = ddlGroups.value;
	//alert(selectedValue);

	if(selectedValue == "Other"){

	
}else {

	document.getElementsById('CartSpecialInstructions').text = selectedValue;
}

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["groupscart-template"]) return;
  try {
    

        $(document).ready(function() {
          
          $.ajax({  
                type: "GET", url: "https://a.klaviyo.com/api/v2/group/TwDFax/members/all?api_key=pk_c2fa60fa7b30eb977ca120a320429af8ec", dataType: "json", contentType: "application/json", success: function (res)  
                {  
                    $.each(res.d, function (data, value) {  
                      
                 
                        $.ajax({  
                			type: "GET", url: "https://a.klaviyo.com/api/v1/person/" + value.id + "?api_key=01F94X5VE7DPSHH0N90VN9AR8B", dataType: "json", contentType: "application/json", success: function (res)  
                            {  
                                $.each(res.d, function (data, value) {  

                                    //$("#DdlOrgGroups").append($("<option></option>").val(value.id).html(value.email));  
                                })  
                            }  
  
            				});  
                      
                        //$("#DdlOrgGroups").append($("<option></option>").val(value.id).html(value.email));  
                    })  
                }  
  
            });  
          

        });


  } catch(e) { console.error(e); }
})();
})();
